import { GoogleAdsRequestTypeGq } from './GoogleAdsRequestTypeGq';
import { GoogleAdsParsingStatusGq } from './GoogleAdsParsingStatusGq';

export interface GoogleAdsRequestGq {
  id: number;
  parentProjectId: number;
  name: string | null;

  // Processing info
  createdTime: string;
  parsingStatus: GoogleAdsParsingStatusGq;
  paused: boolean;
  duplicateCheck: boolean;

  // Request info
  locationId: number | null;
  languageId: number | null;
  locationName: string | null;
  languageName: string | null;
  minSearchVolume: number;
  includeMonths: boolean;
  includeRankData: boolean;
  googleAdsRequestType: GoogleAdsRequestTypeGq;
  searchSource: string;
  searchSourceIds: number[];
  comboId?: number;
  suggestionsWord: boolean;
  suggestionsAlphabeticals: boolean;
  suggestionsNumbers: boolean;
  suggestionsQuestions: boolean;
  suggestionsComparisons: boolean;
  suggestionsPrepositions: boolean;
  useSeedSpecificTagging: boolean;
}

export const GoogleAdsRequestGqProps = `
  id
  parentProjectId
  name
  
  createdTime
  parsingStatus
  paused
  duplicateCheck
  
  locationId
  languageId
  locationName
  languageName
  minSearchVolume
  includeMonths
  includeRankData
  googleAdsRequestType
  searchSource
  searchSourceIds
  comboId
  suggestionsWord
  suggestionsAlphabeticals
  suggestionsNumbers
  suggestionsQuestions
  suggestionsComparisons
  suggestionsPrepositions

  useSeedSpecificTagging
`;
